import { getSlugId } from "../utilities/model-utils";
import { Board, BoardPayload } from "./board";
import { Door } from "./door";
import { Locker } from "./locker";
import { Screen, ScreenPayload } from "./screen";
import {
  WithDimensionAndTimestamps
} from "./withDimension";

export type PucPayload = {
  id?: string,
  origin_x_cm: number,
  origin_y_cm: number,
  width_cm: number,
  height_cm: number,
  serial: string,
  boards: Array<BoardPayload>,
  screens: Array<ScreenPayload>
};

export class Puc implements WithDimensionAndTimestamps {
  public id = '';
  public origin_x_cm = 0;
  public origin_y_cm = 0;
  public width_cm = 1;
  public height_cm = 1;
  public cabinet_id = '';
  public serial = 'CHANGEME';
  public boards: Board[] = [];
  public screens: Screen[] = [];
  public isAddon = false;
  
  static generateNewPuc(nextBoardAddress: number, addScreen?: boolean, originX?: number, originY?: number, width?: number, height?: number): Puc {
    const newPuc = new Puc();
    newPuc.id = getSlugId();
    newPuc.serial = `CHANGEME 123`;
    newPuc.origin_x_cm = originX || 0;
    newPuc.origin_y_cm = originY || 0;
    newPuc.width_cm = width || 100;
    newPuc.height_cm = height || 150;

    const newBoard = new Board();
    newBoard.id = getSlugId();
    newBoard.puc_id = newPuc.id ;
    newBoard.slave_address = nextBoardAddress;
    newBoard.serial = "CHANGEME";
    
    const newLocker = new Locker();
    newLocker.label = '?';
    newLocker.width_cm = 50;
    newLocker.height_cm = 50;
    newLocker.origin_x_cm = newPuc.width_cm / 2 - newLocker.width_cm / 2;
    newLocker.origin_y_cm = newPuc.height_cm / 2 - newLocker.height_cm / 2;
    newLocker.id = getSlugId();
    newLocker.board_id = newBoard.id;
    newLocker.hardware_index = 0;

    const newDoor = new Door();
    newDoor.id = getSlugId();
    newDoor.locker_id = newLocker.id;
    newDoor.location = 'front';
    newLocker.doors.push(newDoor);

    newBoard.lockers.push(newLocker);
    newPuc.boards.push(newBoard);
    
    if (addScreen) {
      const newScreen = new Screen();
    
      newScreen.id = Math.floor(Math.random() * 100);
      newScreen.puc_id = newPuc.id;
      newScreen.location = 'front';
      newScreen.role = 'pickup';
      newScreen.connection = 'primary';
      newPuc.screens.push(newScreen);
    }

    return newPuc;
  }

  static payload(args: Puc, isNew = false): PucPayload {
    const payload: PucPayload = {
      id: args.id,
      origin_x_cm: args.origin_x_cm,
      origin_y_cm: args.origin_y_cm,
      width_cm: args.width_cm,
      height_cm: args.height_cm,
      serial: args.serial,
      boards: Board.boardsPayload(args.boards, isNew),
      screens: Screen.screensPayload(args.screens, isNew)
    };
    
    if (isNew) {
      const {id: _, ...sanitized} = payload;
      return sanitized;
    }

    return payload;
  }

  static pucsPayload(args: Array<Puc>, isNew = false): Array<PucPayload> {
    const temp = [];
    for (const puc of args) {
      temp.push(Puc.payload(puc, isNew));
    }

    return temp;
  }

  static fromObject(args: Puc): Puc {
    let newPuc = new Puc();

    if (args) {
      newPuc = Object.assign(new Puc, args);
      newPuc.id = getSlugId();
      newPuc.boards = [];
      newPuc.screens = [];
      const boards: Board[] = [];
      const lockers: Locker[] = [];
      const doors: Door[] = [];
      const screens: Screen[] = [];

      for (const board of args.boards) {
        const newBoard = Object.assign(new Board, board);
        newBoard.puc_id = newPuc.id;
        newBoard.id = getSlugId();
        newBoard.lockers = [];
        
        for (const locker of board.lockers) {
          const newLocker = Object.assign(new Locker, locker);
          newLocker.id = getSlugId();
          newLocker.board_id = newBoard.id;
          newLocker.doors = [];
          for (const door of locker.doors) {
            const newDoor = Object.assign(new Door, door);
            newDoor.id = getSlugId();
            newDoor.locker_id = newLocker.id;
            doors.push(newDoor);
            newLocker.doors.push(newDoor);
          }
          lockers.push(newLocker);
          newBoard.lockers.push(newLocker);
        }
        boards.push(newBoard);
      }
      
      for (const screen of args.screens) {
        const newScreen = Object.assign(new Screen, screen);
        screen.puc_id = newPuc.id;
        screens.push(newScreen);
        newPuc.screens.push(newScreen);
      }
      newPuc.boards = boards;
    }

    return newPuc;
  }
}
